import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import AggregationMenu from "@/views/AggregationMenu.vue";
import Disaster from "@/views/Disaster";
import Oil from "@/views/Oil";
import Manager from "@/views/Manager";
import ManagerOrder from "@/views/ManagerOrder";
import ManagerOrderView from "@/views/ManagerOrderView";
import ManagerOrderManagement from "@/views/ManagerOrderManagement";
import Evacuation from "@/views/Evacuation";
import EvacuationOrderManagement from "@/views/EvacuationOrderManagement";
import PushNotification from "@/views/PushNotification";
import PushNotificationView from "@/views/PushNotificationView";
import EmergencyMail from "@/views/EmergencyMail";
import EmergencyMailView from "@/views/EmergencyMailView";
import Lalert from "@/views/Lalert";
import LalertManagement from "@/views/LalertManagement";
import LalertNotification from "@/views/LalertNotification";
import LalertNotificationView from "@/views/LalertNotificationView";
import LalertEvacuation from "@/views/LalertEvacuation";
import LalertEvacuationView from "@/views/LalertEvacuationView";
import EvacueeStatus from "@/views/EvacueeStatus";
import EvacueeSearch from "@/views/EvacueeSearch";
import Chronology from "@/views/Chronology";
import FacilityQrCode from "@/views/FacilityQrCode";
import FacilityQrCodeGroup from "@/views/FacilityQrCodeGroup";
import FacilityQrCodeRegister from "@/views/FacilityQrCodeRegister";
import FacilityQrCodeIssue from "@/views/FacilityQrCodeIssue";
import TemporaryQrCode from "@/views/TemporaryQrCode";
import TemporaryQrCodeGroup from "@/views/TemporaryQrCodeGroup";
import TemporaryQrCodeRegister from "@/views/TemporaryQrCodeRegister";
import TemporaryQrCodeIssue from "@/views/TemporaryQrCodeIssue";
import BusQrCode from "@/views/BusQrCode";
import BusQrCodeIssue from "@/views/BusQrCodeIssue";
import FacilityVulnerPeople from "@/views/FacilityVulnerPeople";
import FacilityNuclearDisaster from "@/views/FacilityNuclearDisaster";
import FacilityStatus from "@/views/FacilityStatus";
import FacilityStatusVulnerPeople from "@/views/FacilityStatusVulnerPeople";
import FacilityStatusNuclearDisaster from "@/views/FacilityStatusNuclearDisaster";
import StableIodine from "@/views/StableIodine";
import StableIodineList from "@/views/StableIodineList";
import StableIodineSearch from "@/views/StableIodineSearch";
import StableIodineDistribution from "@/views/StableIodineDistribution";
import User from "@/views/User";
import UserAuthorizationOperation from "@/views/UserAuthorizationOperation";
import Car from "@/views/Car";
import CarList from "@/views/CarList";
import CarRegister from "@/views/CarRegister";
import EquipmentDeployRegister from "@/views/EquipmentDeployRegister";
import InspectionResultList from "@/views/InspectionResultList";
import DisasterFixedphraseMst from "@/views/DisasterFixedphraseMst";
import InfoGuideMst from "@/views/InfoGuideMst";
import Autonomy from "@/views/Autonomy";
import AdjustmentSystem from "@/views/AdjustmentSystem";
import SeamlessLogin from "@/views/SeamlessLogin";
import NotFound from "@/views/NotFound";
import Error from "@/views/Error";
import store from "@/store";
import cognito from "@/js/cognito";
import { hasProperty } from "@/js/utils";

Vue.use(VueRouter);

const logout = (to, from, next) => {
  cognito.logout();
  const types = [
    "defaultDisaster/clearDisaster",
    "screenAuthority/clearScreenAuthority"
  ];
  types.forEach(type => {
    store.dispatch(type);
  });
  next("/");
};

const routes = [
  {
    name: "home",
    path: "/",
    component: Home,
    meta: {
      notRequiredAuth: true
    }
  },
  {
    name: "aggregation-menu",
    path: "/aggregation-menu",
    component: AggregationMenu
  },
  {
    name: "disaster",
    path: "/disaster",
    component: Disaster
  },
  {
    name: "oil",
    path: "/oil",
    component: Oil
  },
  {
    path: "/evacuation-order",
    component: Evacuation,
    children: [
      {
        name: "evacuation-order-management",
        path: "",
        component: EvacuationOrderManagement,
        props: true
      },
      {
        name: "push-notification-create",
        path: "push-notification-create",
        component: PushNotification,
        props: true
      },
      {
        name: "push-notification-edit",
        path: "push-notification-edit",
        component: PushNotification,
        props: true
      },
      {
        name: "push-notification-view",
        path: "push-notification-view",
        component: PushNotificationView,
        props: true
      },
      {
        name: "push-notification-duplicate",
        path: "push-notification-duplicate",
        component: PushNotification,
        props: true
      },
      {
        name: "emergency-mail-create",
        path: "emergency-mail-create",
        component: EmergencyMail,
        props: true
      },
      {
        name: "emergency-mail-edit",
        path: "emergency-mail-edit",
        component: EmergencyMail,
        props: true
      },
      {
        name: "emergency-mail-view",
        path: "emergency-mail-view",
        component: EmergencyMailView,
        props: true
      },
      {
        name: "emergency-mail-duplicate",
        path: "emergency-mail-duplicate",
        component: EmergencyMail,
        props: true
      }
    ]
  },
  {
    path: "/lalert",
    component: Lalert,
    children: [
      // L-アラート一覧画面
      {
        name: "lalert-management",
        path: "",
        component: LalertManagement,
        props: true
      },
      // Lアラート登録・編集（お知らせ）
      {
        name: "lalert-notification-create",
        path: "lalert-notification-create",
        component: LalertNotification,
        props: true
      },
      // Lアラート登録・編集（お知らせ）
      {
        name: "lalert-notification-edit",
        path: "lalert-notification-edit",
        component: LalertNotification,
        props: true
      },
      // Lアラート参照（お知らせ）
      {
        name: "lalert-notification-view",
        path: "lalert-notification-view",
        component: LalertNotificationView,
        props: true
      },
      // Lアラート登録・編集（お知らせ）
      {
        name: "lalert-notification-duplicate",
        path: "lalert-notification-duplicate",
        component: LalertNotification,
        props: true
      },
      // Lアラート登録・編集（避難情報）
      {
        name: "lalert-evacuation-create",
        path: "lalert-evacuation-create",
        component: LalertEvacuation,
        props: true
      },
      // Lアラート登録・編集（避難情報）
      {
        name: "lalert-evacuation-edit",
        path: "lalert-evacuation-edit",
        component: LalertEvacuation,
        props: true
      },
      // Lアラート参照（避難情報）
      {
        name: "lalert-evacuation-view",
        path: "lalert-evacuation-view",
        component: LalertEvacuationView,
        props: true
      },
      // Lアラート登録・編集（避難情報）
      {
        name: "lalert-evacuation-duplicate",
        path: "lalert-evacuation-duplicate",
        component: LalertEvacuation,
        props: true
      }
    ]
  },
  {
    name: "shelter-status",
    path: "/shelter-status",
    component: EvacueeStatus
  },
  {
    name: "evacuee-status",
    path: "/evacuee-status",
    component: EvacueeSearch
  },
  {
    name: "chronology",
    path: "/chronology",
    component: Chronology
  },
  {
    path: "/facility-qr-code",
    component: FacilityQrCode,
    children: [
      {
        name: "facility-qr-code-group",
        path: "",
        component: FacilityQrCodeGroup
      },
      {
        name: "facility-qr-code-register",
        path: "register",
        component: FacilityQrCodeRegister
      },
      {
        name: "facility-qr-code-issue",
        path: "issue",
        component: FacilityQrCodeIssue
      }
    ]
  },
  {
    path: "/school-qr-code",
    component: FacilityQrCode,
    children: [
      {
        name: "school-qr-code-group",
        path: "",
        component: FacilityQrCodeGroup
      },
      {
        name: "school-qr-code-register",
        path: "register",
        component: FacilityQrCodeRegister
      },
      {
        name: "school-qr-code-issue",
        path: "issue",
        component: FacilityQrCodeIssue
      }
    ]
  },
  {
    path: "/temporary-qr-code",
    component: TemporaryQrCode,
    children: [
      {
        name: "temporary-qr-code-group",
        path: "",
        component: TemporaryQrCodeGroup
      },
      {
        name: "temporary-qr-code-register",
        path: "register",
        component: TemporaryQrCodeRegister
      },
      {
        name: "temporary-qr-code-issue",
        path: "issue",
        component: TemporaryQrCodeIssue
      }
    ]
  },
  {
    path: "/bus-qr-code",
    component: BusQrCode,
    children: [
      {
        name: "bus-qr-code-issue",
        path: "",
        component: BusQrCodeIssue
      }
    ]
  },
  {
    name: "facility-status",
    path: "/facility-status",
    component: FacilityStatus,
    children: [
      {
        name: "facility-status-vulner-people",
        path: "vulner-people",
        component: FacilityStatusVulnerPeople
      },
      {
        name: "facility-status-nuclear-disaster",
        path: "nuclear-disaster",
        component: FacilityStatusNuclearDisaster
      }
    ]
  },
  {
    path: "/stable-iodine",
    component: StableIodine,
    children: [
      {
        name: "stable-iodine-list",
        path: "",
        component: StableIodineList
      }
    ]
  },
  {
    path: "/stable-iodine-personal",
    component: StableIodine,
    children: [
      {
        name: "stable-iodine-personal",
        path: "",
        component: StableIodineSearch
      }
    ]
  },
  {
    name: "user",
    path: "/user",
    component: User
  },
  {
    name: "user-authorization-operation",
    path: "/user-authorization-operation",
    component: UserAuthorizationOperation
  },
  {
    path: "/car",
    component: Car,
    children: [
      {
        path: "",
        component: CarList
      },
      {
        path: "register/:type",
        component: CarRegister,
        children: [
          {
            path: ":id"
          }
        ]
      }
    ]
  },
  {
    path: "/manager-order",
    component: Manager,
    children: [
      {
        name: "manager-order-management",
        path: "",
        component: ManagerOrderManagement,
        props: true
      },
      {
        name: "manager-order-create",
        path: "create",
        component: ManagerOrder,
        props: true
      },
      {
        name: "manager-order-edit",
        path: "edit",
        component: ManagerOrder,
        props: true
      },
      {
        name: "manager-order-view",
        path: "view",
        component: ManagerOrderView,
        props: true
      },
      {
        name: "manager-order-duplicate",
        path: "duplicate",
        component: ManagerOrder,
        props: true
      }
    ]
  },
  {
    name: "stable-iodine-register",
    path: "/stable-iodine-register",
    component: StableIodineDistribution
  },
  {
    name: "/equipment-deploy-register",
    path: "/equipment-deploy-register",
    component: EquipmentDeployRegister
  },
  {
    name: "/inspection-result-list",
    path: "/inspection-result-list",
    component: InspectionResultList
  },
  {
    name: "disaster-prevention-fa-mst",
    path: "/disaster-prevention-fa-mst",
    component: FacilityNuclearDisaster
  },
  {
    name: "vulner-people-fa-mst",
    path: "/vulner-people-fa-mst",
    component: FacilityVulnerPeople
  },
  {
    name: "disaster-fixedphrase-mst",
    path: "/disaster-fixedphrase-mst",
    component: DisasterFixedphraseMst
  },
  {
    name: "info-guide-mst",
    path: "/info-guide-mst",
    component: InfoGuideMst
  },
  {
    name: "autonomy-mst",
    path: "/autonomy-mst",
    component: Autonomy
  },
  {
    name: "adjustment-system",
    path: "/adjustment-system",
    component: AdjustmentSystem
  },
  {
    name: "seamless-login",
    path: "/seamless-login",
    component: SeamlessLogin,
    meta: {
      notRequiredAuth: true
    }
  },
  {
    name: "logout",
    path: "/logout",
    beforeEnter: logout
  },
  {
    name: "error",
    path: "/error",
    component: Error,
    meta: { notRequiredAuth: true }
  },
  {
    name: "not-found",
    path: "*",
    component: NotFound,
    meta: { notRequiredAuth: true }
  }
];

routes.forEach(route => {
  if (hasProperty(route, "meta")) {
    if (
      hasProperty(route.meta, "requiredAuth") ||
      hasProperty(route.meta, "notRequiredAuth")
    ) {
      return;
    }
    Object.assign(route.meta, {
      requiredAuth: true
    });
  } else {
    Object.assign(route, {
      meta: {
        requiredAuth: true
      }
    });
  }
});

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  } // 画面遷移後、画面のトップに移動
});

router.beforeResolve(async (to, from, next) => {
  // -------------------------------------------------------
  // Cognito認証なしモードの場合には、認証確認処理をスキップ
  if (process.env.VUE_APP_COGNITO === "invalid") {
    next();
    return;
  }
  // -------------------------------------------------------
  cognito
    .isAuthenticated()
    .then(session => {
      const token = session.idToken.jwtToken;
      // idTokenの有効期間が切れていた場合、即実行すると
      // 古いidTokenが使用されるため少し遅らせて実行している
      setTimeout(() => {
        cognito
          .getAttribute()
          .then(result => {
            const user = {};
            for (let v of result) {
              user[v.getName()] = v.getValue();
            }
            user["token"] = token;
            store.dispatch("cognito/setUser", user);
          })
          .catch(() => {
            store.dispatch("cognito/setUser", null);
            logout(to, from, next);
          });
        if (to.matched.some(record => record.meta.notRequiredAuth)) {
          next();
        }
      }, 50);
    })
    .catch(() => {
      store.dispatch("cognito/setUser", null);
      if (to.matched.some(record => record.meta.requiredAuth)) {
        next({
          path: "/",
          query: { redirect: to.fullPath }
        });
      }
    });
  next();
});

export default router;
